<div layout="column">
  <div layout="row"
       layout-align="space-between start"
       flex>
    <div mat-dialog-title>
      <span class="edit-screen-title"
            [translate]="'bankInfo.consent.permissionsTitle'">
        Права на съгласие
      </span>
    </div>
    <button tabindex="-1"
            class="close-mat-dialog"
            mat-icon-button
            (click)="onCloseClicked()">
      <mat-icon>clear</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    @if (permissions.length > 0) {
    <mat-chip-listbox class="permissions-list">
      @for (perm of permissions; track perm.name) {
      <mat-chip class="permission-tag">{{ 'bankInfo.activity.permissions.' + perm.name | translate }}</mat-chip>
      }
    </mat-chip-listbox>
    } @else {
    <p [translate]="'bankInfo.permissions.none'">Няма права</p>
    }
  </mat-dialog-content>
</div>
